var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-window"},[(_vm.showTopBar)?_c('top-bar'):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }